module.exports = __webpack_public_path__ + "h5/img/empty-no-word.bcd6a54c.png";